import Page from '../../components/Page';
import React from 'react';
import {Card, CardBody, CardHeader, Col, Row, Table, Input, Button, Label} from 'reactstrap';
import connect from "react-redux/es/connect/connect";
import {MdDone} from "react-icons/lib/md";
import {Link} from "react-router-dom";
import API from "../../resources/index";

class AuditFormPage extends React.Component {
    companyResource = API.companyResource;
    auditResource = API.auditResource;

    constructor() {
        super();
        this.state = {
            companies: [],
            observation: ''
        }
    }

    getCompanies = () => {
        this.companyResource.query({
            keys: {
                expand: [
                    'manager',
                    'audit'
                ]
            }
        })
            .then(response => {
                if (response.status === 200) {
                    this.setState({companies: response.data});
                }
            })
    };

    componentDidMount() {
        this.getCompanies();
    }

    handleAudit = (company_id) => {
        this.auditResource.create({
            company_id: company_id,
            observation: this.state.observation
        })
            .then(() => {
                this.getCompanies();
            });
    };

    handleInput = (event) => {
        this.setState({observation: event.target.value});
    };

    render() {
        return <Page
            title="Realizar Auditoria"
            icon='MdAssignment'
            // breadcrumbs={[{name: 'Auditorias Realizadas', active: false}, {name: 'Realizar Auditoria', active: true}]}
            className="">
            <Row>
                <Col>
                    <Card className="mb-3">
                        <CardHeader>
                            <Link className='btn btn-secondary' to="/audits">Auditorias Realizadas</Link>
                        </CardHeader>
                        <CardBody>
                            <Table responsive>
                                <thead>
                                <tr>
                                    <th>Feito</th>
                                    <th>Observação</th>
                                    <th>Razão Social / Nome Fantasia</th>
                                    <th>Gestor</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.companies.map(company => {
                                    return <tr key={company.id}>
                                        <td>
                                            <Label check style={{
                                                display: 'block',
                                                margin: 'auto 20px',
                                                width: 0
                                            }}>
                                                <Button color="primary"
                                                        onClick={() => {
                                                            if (!Boolean(company.audit)) this.handleAudit(company.id)
                                                        }}
                                                        active={!Boolean(company.audit)}
                                                        disabled={Boolean(company.audit)}>
                                                    <MdDone/>
                                                </Button>
                                            </Label>
                                            {Boolean(company.audit) && 'Feito hoje!'}
                                        </td>
                                        <td>
                                            <Input disabled={Boolean(company.audit)}
                                                   type='textarea'
                                                   onChange={this.handleInput}
                                                   value={company.audit && company.audit.observation}/>
                                        </td>
                                        <td>{company.social_name}</td>
                                        <td>{company.manager && company.manager.name}</td>
                                    </tr>
                                })}

                                {!this.state.companies.length && <tr>
                                    <td colSpan={4} style={{textAlign: 'center'}}>Não há itens para
                                        exibição
                                    </td>
                                </tr>}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Page>
    };
}

const mapStateToProps = state => {
    return {user: state.userReducer.user};
};

export default connect(mapStateToProps)(AuditFormPage);



// WEBPACK FOOTER //
// ./src/pages/audit/AuditFormPage.js